/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { DispositivosContext } from 'contexts/DispositivosContext';
import { Modal, Form, Row, Col, Input, message, Select } from 'antd';
import { Button } from 'components';
import Cookie from 'universal-cookie';
import { deleteAssignment, deleteDevice, editAssignDevice } from 'actions/devices.actions';
import * as MensGrales from 'constants/MensajesGenerales';
import './ModalDispo.scss';

// eslint-disable-next-line react/prop-types
function ModalDispo({ title, open, callback, asigToEdit, tipoModal, encuestadores }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { counter, setCounter } = useContext(DispositivosContext);
  const [messageApi, contextHolder] = message.useMessage();
  let tokken = null;
  const coki = new Cookie();

  const handleCancel = () => {
    callback(false);
  };

  /**
   * Elimina una asignación de dispositivo
   */
  const onEliminarAsig = async () => {
    tokken = coki.get('JWT-TOKEN-SIMAC');
    const data = {
      asignacion: {
        idDispositivo: asigToEdit.idDispositivo,
        idUsuario: asigToEdit.idUsuario
      },
      token: tokken
    };
    const { success, response } = await dispatch(deleteAssignment(data));
    if (success && response?.data.code === 200) {
      messageApi.open({
        type: 'success',
        content: 'Registro eliminado',
        duration: 2
      });
      setCounter(counter + 1);
    } else if (response?.causa !== undefined) {
      message.error(response.causa);
    } else {
      message.error(MensGrales.MAV1_2);
    }
    callback(false);
  };

  /**
   * Elimina un dispositivo y su asignación
   */
  const onEliminar = async () => {
    tokken = coki.get('JWT-TOKEN-SIMAC');
    const data = {
      asignacion: {
        idDispositivo: asigToEdit.idDispositivo,
        idUsuario: asigToEdit.idUsuario
      },
      token: tokken
    };
    const { success, response } = await dispatch(deleteDevice(data));
    if (success && response?.data.code === 200) {
      message.success('Registro eliminado');
      setCounter(counter + 1);
    } else if (response?.causa !== undefined) {
      message.error(response.causa);
    } else {
      message.error(MensGrales.MAV1_2);
    }
    callback(false);
  };

  const onFinish = async (values) => {
    tokken = coki.get('JWT-TOKEN-SIMAC');
    if (values?.nombre === asigToEdit?.nombre) {
      message.error('Seleccione un encuestador distinto al actual');
    } else {
      const data = {
        asignacion: {
          idDispositivo: asigToEdit.idDispositivo,
          idUsuario: values.nombre
        },
        token: tokken
      };
      const { success, response } = await dispatch(editAssignDevice(data));
      if (success && response?.data.code === 200) {
        message.success('Guardado exitoso');
        callback(false);
        setCounter(counter + 1);
      } else {
        message.error(response.causa);
      }
    }
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={handleCancel}
      centered
      width={tipoModal === 1 ? '65%' : '35%'}
      className={tipoModal === 1 ? 'modal-editar modal-simac' : 'modal-eliminar modal-simac'}
      footer={null}>
      {contextHolder}
      {tipoModal === 1 ? (
        <div id="formularioModal">
          <Form
            id="formAssign"
            layout="vertical"
            form={form}
            initialValues={asigToEdit}
            onFinish={onFinish}>
            <Row gutter={[20, 24]} style={{ width: '100%' }}>
              <Col span={8}>
                <Form.Item
                  name="imei"
                  label="IMEI:"
                  className=""
                  rules={[{ required: true, message: 'Dato requerido.' }]}>
                  <Input
                    style={{ width: '98%' }}
                    // eslint-disable-next-line react/prop-types
                    value={asigToEdit.imei}
                    placeholder="Número IMEI"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="nombre"
                  label="Encuestador:"
                  className=""
                  rules={[{ required: true, message: 'Dato requerido.' }]}>
                  <Select
                    style={{ width: '98%' }}
                    placeholder={asigToEdit.nombre}
                    allowClear
                    options={(encuestadores || []).map((e) => ({
                      value: e.idUsuario,
                      label: `${e.nombre} ${e.apellidoPaterno ? e.apellidoPaterno : ''} ${
                        e.apellidoMaterno ? e.apellidoMaterno : ''
                      }`
                    }))}
                    optionFilterProp="label"
                    filterOption={(input, option) => {
                      return option.label.toLowerCase().includes(input.toLowerCase());
                    }}
                    showSearch
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24} className="center-element" style={{ marginTop: '5px' }}>
                <Form.Item name="btnAsignar">
                  <Button type="primary" htmlType="submit" text="Guardar" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      ) : null}
      {tipoModal === 2 ? (
        <div className="center-element" style={{ flexDirection: 'column' }}>
          <p>¿Deseas eliminar el dispositivo?</p>
          <Button text="Aceptar" type="primary" onClick={onEliminar} />
        </div>
      ) : null}
      {tipoModal === 3 ? (
        <div className="center-element" style={{ flexDirection: 'column' }}>
          <p>¿Deseas eliminar la asignación?</p>
          <Button text="Aceptar" type="primary" onClick={onEliminarAsig} />
        </div>
      ) : null}
    </Modal>
  );
}

export default ModalDispo;
